import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';
import { useUser } from '../contexts/UserContext';

const ClientContext = createContext();
export const useClient = () => useContext(ClientContext);

export const ClientProvider = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [isClientLoading, setIsClientLoading] = useState(true);
  const { user } = useUser();
  const [fetched, setFetched] = useState(false);
  const [fetchedUserId, setFetchedUserId] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const fetchClients = async () => {
      try {
        if (user && user.role_id !== '2' && user.id !== fetchedUserId) {
          const res = await api.get('/ticket/customer-projects', {
            params: { user_id: user.user_id },
            signal: controller.signal,
          });
          if (res.data.status && Array.isArray(res.data.data)) {
            setClients(res.data.data);
          }
          setFetchedUserId(user.id);
        }
      } catch (error) {
        if (error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') return;
        console.error('Client API fetch failed:', error);
      } finally {
        setIsClientLoading(false);
      }
    };

    fetchClients();
    return () => controller.abort();
  }, [user, fetchedUserId]);

  return (
    <ClientContext.Provider value={{ clients, selectedClientId, setSelectedClientId, isClientLoading }}>
      {children}
    </ClientContext.Provider>
  );
};
